/**
 * 路由各项配置
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import { routeMap } from './../utils/com.js'
const COM_LOGIN = () => import('../components/logins/login.vue')

const COM_PRESS_INDEX = () => import('../components/press/index.vue')
const COM_PRESS_LIST = () => import('../components/press/list.vue')
const COM_PRESS_SEARCH = () => import('../components/press/search.vue')
const COM_PRESS_REVIEW = () => import('../components/press/review.vue')

const COM_JOKE = () => import('../components/joke/index.vue')

const COM_404 = () => import('../components/common/notfound.vue')
// 全局使用路由
Vue.use(VueRouter)

const routes = [
    {
        name: 'home',
        path: routeMap('/'),
        redirect: routeMap('/press')
    },
    // { path: '/userlogin/:type?',
    //   redirect: to => {
    //     const { params } = to
    //     console.debug("to:%o, params:%o", to, params);
    //     // if (query.type === 'foo') {
    //     //   return { path: '/foo', query: null }
    //     // }
    //     // if (hash === '#baz') {
    //     //   return { name: 'baz', hash: '' }
    //     // }
    //     if (params.type) {
    //       return routeMap('/login?type=:type')
    //     } else {
    //       return routeMap('/login')
    //     }
    //   }
    // },
    {
        name: 'login',
        path: routeMap('/login'), //'/login',
        component: COM_LOGIN //require('../components/logins/login.vue')
    },
    // {
    //     name: 'ieditor',
    //     path: routeMap('/ieditor'),
    //     redirect: routeMap('/ieditor/list'),
    //     component: require('../components/ieditor/index.vue'),
    //     children: [
    //         {
    //             name: 'ieditorlist',
    //             path: 'list',
    //             component: require('../components/ieditor/list.vue')
    //         },
    //         {
    //             name: 'ieditoredit',
    //             path: 'edit',
    //             component: require('../components/ieditor/edit.vue')
    //         },
    //         {
    //             name: 'ieditorreview',
    //             path: 'review',
    //             component: require('../components/ieditor/review.vue')
    //         }
    //     ]
    // },
    // {
    //     name: 'irecord',
    //     path: routeMap('/irecord'),
    //     redirect: routeMap('/irecord/list'),
    //     component: require('../components/irecord/index.vue'),
    //     children: [
    //         {
    //             name: 'irecordlist',
    //             path: 'list',
    //             component: require('../components/irecord/list.vue')
    //         },
    //         {
    //             name: 'irecordedit',
    //             path: 'edit',
    //             component: require('../components/irecord/edit.vue')
    //         }
    //     ]
    // },
    // {
    //     name: 'audit',
    //     path: routeMap('/audit'),
    //     redirect: routeMap('/audit/list'),
    //     component: require('../components/audit/index.vue'),
    //     children: [
    //         {
    //             name: 'auditlist',
    //             path: 'list',
    //             component: require('../components/audit/list.vue')
    //         },
    //         {
    //             name: 'auditreview',
    //             path: 'review',
    //             component: require('../components/audit/review.vue')
    //         }
    //     ]
    // },
    {
        name: 'press',
        path: routeMap('/press'),
        redirect: routeMap('/press/list'),
        component: require('../components/press/index.vue'),
        children: [
            {
                name: 'presslist',
                path: 'list',
                component: COM_PRESS_LIST //require('../components/press/list.vue')
            },
            {
                name: 'presssearch',
                path: 'search',
                component: COM_PRESS_SEARCH //require('../components/press/search.vue')
            },
            {
                name: 'pressreview',
                path: 'review',
                component: COM_PRESS_REVIEW //require('../components/press/review.vue')
            }
        ]
    },
    {
        name: 'joke',
        path: routeMap('/joke'),
        component: COM_JOKE
    },
    // {
    //     name: 'stats',
    //     path: routeMap('/stats'),
    //     redirect: routeMap('/stats/list'),
    //     component: require('../components/stats/index.vue'),
    //     children: [
    //         {
    //             name: 'statslist',
    //             path: 'list',
    //             component: require('../components/stats/list.vue')
    //         },
    //         {
    //             name: 'statsevents',
    //             path: 'events',
    //             component: require('../components/stats/events.vue')
    //         },
    //         {
    //             name: 'statsinterface',
    //             path: 'interface',
    //             component: require('../components/stats/interface.vue')
    //         },
    //         {
    //             name: 'statsreview',
    //             path: 'review',
    //             component: require('../components/stats/review.vue')
    //         },
    //         {
    //             name: 'statslabels',
    //             path: 'labels',
    //             component: require('../components/stats/labels.vue')
    //         }
    //     ]
    // },
    {
        name: 'notfound',
        path: routeMap('/404'),
        component: COM_404 //require('../components/common/notfound.vue')
    },
    { // 404页面路由必须放最后,引导所有未知链接跳转404
        path: '*',
        redirect: routeMap('/404')
    }
]

// 路由配置
const router = new VueRouter({
    mode: 'history',
    base: __dirname,
    scrollBehavior: () => ({y : 0}),
    routes: routes
})

export  default router



// WEBPACK FOOTER //
// ./src/router/router.js